
const ImgCotizacionOK = () => <img width={50} src={require(`./Icono1.svg`).default} alt='imagen' />
const ImgErrorInfo = () => <img width={50} src={require(`./Icono2.svg`).default} alt='imagen' />
const ImgWaitMail = () => <img width={50} src={require(`./Icono3.svg`).default} alt='imagen' />
const ImgAtenInfo = ({ wth: number = 50  }: any) => <img width={number} src={require(`./Icono4.svg`).default} alt='imagen' />
const ImgWspInfo = ({ wth: number = 50  }) => <img width={number} src={require(`./Icono5.svg`).default} alt='imagen' />
const ImgErrorInfo2 = ({ wth: number = 50  }) => <img width={number} src={require(`./Icono6.svg`).default} alt='imagen' />



export {
    ImgWaitMail,
    ImgErrorInfo,
    ImgCotizacionOK,
    ImgAtenInfo,
    ImgWspInfo,
    ImgErrorInfo2
}